var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdfvuer"},[(_vm.url_pdf)?_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":("https://docs.google.com/gview?url=" + _vm.url_pdf + "&embedded=true"),"frameborder":"0"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }